import React from "react";
import InputField from "../../../atoms/InputField";

const MeetingFormFields = ({ values, setFieldValue }) => {
	return (
		<div className="w-full flex flex-col md:flex-row space-y-2 md:space-y-0 md:space-x-4">
			<InputField
				name="subject"
				label="Asunto"
				placeholder="Asunto"
				value={values.subject}
				onChange={(e) => setFieldValue("subject", e.target.value)}
			/>
			<InputField
				name="location"
				label="Lugar"
				placeholder="Lugar de la reunión"
				value={values.location}
				onChange={(e) => setFieldValue("location", e.target.value)}
			/>
			<InputField
				name="createdAt"
				label="Fecha"
				type="datetime-local"
				value={values.createdAt}
				onChange={(e) => setFieldValue("createdAt", e.target.value)}
			/>
		</div>
	);
};

export default MeetingFormFields;
